module.exports = __webpack_public_path__ + "static/media/Soybean11R4.9408432b.PNG";